import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import httpApi from '@/http/api'
import { setGuideTipsBarDismissCookie } from '@zaohaowu/website-common/utils/guideTipsBarCookie'
import { getCookie } from '@/utils/cookie'

export interface ActivityShortTipsPayload {
  show: boolean
  type: string
  content: string
  buttonText: string
  miniAppButtonJumpUrl: string
  webButtonJumpUrl: string
}

const DISMISS_KEY = 'zaohaowu_guide_tips_bar_dismissed'

const isSameLocalCalendarDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate()

const readDismissTimestampMs = (): number | null => {
  const fromCookie = getCookie(DISMISS_KEY)
  if (fromCookie != null && fromCookie !== '') {
    const ts = Number(fromCookie)
    if (Number.isFinite(ts)) return ts
  }
  try {
    const fromLs = localStorage.getItem(DISMISS_KEY)
    if (fromLs != null && fromLs !== '') {
      const ts = Number(fromLs)
      if (Number.isFinite(ts)) {
        setGuideTipsBarDismissCookie(String(ts))
        localStorage.removeItem(DISMISS_KEY)
        return ts
      }
    }
  } catch {
    /* ignore */
  }
  return null
}

const isDismissedToday = () => {
  const ts = readDismissTimestampMs()
  if (ts == null) return false
  return isSameLocalCalendarDay(new Date(ts), new Date())
}

export const useGuideTipsBarStore = defineStore('guideTipsBar', () => {
  const tipsData = ref<ActivityShortTipsPayload | null>(null)
  const showBar = ref(false)

  /** 与原先模板条件一致：有数据且允许展示条 */
  const isGuideTipsBarVisible = computed(() => showBar.value && tipsData.value !== null)

  const applyVisibility = (data: ActivityShortTipsPayload | null) => {
    if (!data?.show || !data.content?.trim()) {
      showBar.value = false
      return
    }
    showBar.value = !isDismissedToday()
  }

  const fetchGuideTips = async () => {
    try {
      const res = await httpApi.getActivityShortTips(
        { type: 'APP_DOWNLOAD' },
        { isShowErrorModal: false }
      )
      tipsData.value = res.data as ActivityShortTipsPayload
      applyVisibility(tipsData.value)
    } catch {
      tipsData.value = null
      showBar.value = false
    }
  }

  const dismiss = () => {
    try {
      setGuideTipsBarDismissCookie(String(Date.now()))
    } catch {
      /* ignore */
    }
    try {
      localStorage.removeItem(DISMISS_KEY)
    } catch {
      /* ignore */
    }
    showBar.value = false
  }

  return {
    tipsData,
    showBar,
    isGuideTipsBarVisible,
    fetchGuideTips,
    dismiss
  }
})
